import { Box, Button, Text } from '@doda/io-react/common';
import { useSetModal } from '../Layout';
import styles from './index.module.scss';

/**
 * 求人結果が見つからない時のコンポーネント
 *
 * @returns {JSX.Element} 求人結果が見つからない時のコンポーネントのJSX要素
 */
export const NoResult = () => {
  const setModal = useSetModal();
  const handleClickChange: NoResultUIProps['onClickChange'] = () => {
    setModal(true);
  };
  return <NoResultUI onClickChange={handleClickChange} />;
};

/**
 * NoResultUIコンポーネントのプロパティ
 */
interface NoResultUIProps {
  /** 希望条件を変更ボタンがクリックされた時のハンドラ関数 */
  onClickChange: VoidFunction;
}

/**
 * 求人結果が見つからない時のUIコンポーネント
 *
 * @param {NoResultUIProps} props - NoResultUIのプロパティ
 * @returns {JSX.Element} 求人結果が見つからない時のUIコンポーネントのJSX要素
 */
export const NoResultUI = ({ onClickChange }: NoResultUIProps) => {
  return (
    <Box
      border="red"
      color="white"
      radius="4"
      className={styles['matchJobList-noResult__box']}
    >
      <Text
        as="p"
        color="red_pc"
        size="20"
        weight="bold"
        className={styles['matchJobList-noResult__message']}
      >
        この希望条件にマッチした求人はありません。
      </Text>
      <Button
        as="button"
        variant="green"
        size="L"
        onClick={onClickChange}
        className={styles['matchJobList-noResult__button']}
      >
        希望条件を変更する
      </Button>
    </Box>
  );
};
